@if (mode=='EDIT') {
@if (!showForm && pageConfig.addAllow) {
<div class="flex justify-end mr-5 mb-3">
  <button type="button" class="inline-flex items-center justify-center min-h-[36px] px-4 rounded-[10px] bg-[#3f7df6] text-white text-[0.84rem] font-medium hover:bg-opacity-90 focus:outline-none focus:ring-[3px] focus:ring-[#3f7df6]/20 transition-colors" (click)="showForm = true">
    Add New
  </button>
</div>
}
<span [hidden]="!showForm">
  <div class="w-full bg-white rounded-xl shadow-sm border border-[#dce4ef] p-6 mb-6">
    <app-form-generator [submitted]="false" [hidden]="pageConfig?.showOnUpdate && !currentData?.id" #dataForm
      (onChangeEvent)="onChange($event)" [formData]="formData" [dynamicValidator]="dynamicValidator"></app-form-generator>
    @if ((pageConfig?.addAllow || pageConfig?.updateAllow) && mode =='EDIT') {
    <div class="mt-6 flex justify-start gap-3" [hidden]="pageConfig?.showOnUpdate && !currentData?.id">
      @if ((pageConfig?.addAllow && !currentData.id) || (pageConfig?.updateAllow && currentData.id) ) {
      <button noDoubleClick (click)="saveData('BTN')" class="inline-flex items-center justify-center min-h-[36px] px-6 rounded-[10px] bg-[var(--theme-bg)] text-white text-[0.84rem] font-medium hover:bg-opacity-90 focus:outline-none focus:ring-[3px] focus:ring-[var(--theme-bg)]/20 transition-colors">
        {{currentData?.id ? ' Update ' :'Add New'}}</button>
      <button (click)="reset()" class="inline-flex items-center justify-center min-h-[36px] px-6 rounded-[10px] bg-[#f0a02b] text-white text-[0.84rem] font-medium hover:bg-opacity-90 focus:outline-none focus:ring-[3px] focus:ring-[#f0a02b]/20 transition-colors">Reset</button>
      }
    </div>
    }
  </div>
  @if (showForm) {
  <a href="javascript:void(0)" class="text-[0.84rem] text-[#657084] hover:text-[#3f7df6]" (click)="hideBtn()">Hide</a>
  }
</span>
}
@if (mode == 'MODIFICATION') {
<div class="text-right mb-4 text-[0.84rem] text-[#657084]">
  <i class="pi pi-circle-on text-[#2fb171] ml-2 mr-1"></i> New
  <i class="pi pi-circle-on text-[#f0a02b] ml-2 mr-1"></i> Update
  <i class="pi pi-circle-on text-[#df5b5b] ml-2 mr-1"></i> Delete
</div>
}
@if (tblBuild?.column) {
<app-table-list #tbl [tableConfig]="tblBuild" [parenttblAction]="tblAction"
  [parentGetList]="getListData"></app-table-list>
}